import { call, put, select, takeEvery } from 'redux-saga/effects';
import MixPanel from 'mixpanel-browser';
import SagaUtils from 'Utils/SagaUtils';
import ApiService from '../../../Services/ApiService';
import { displayNotification } from '../../../Utils/GenericUtils';
import { BillingActions } from './actions';
import { BillingSelectors } from './selectors';

export function* fetchBillingInfo() {
  try {
    const billingInfo = yield call(ApiService.getBillingInformation);
    yield put(BillingActions.billingInfoFetchSucceeded(billingInfo));
  } catch (e) {
    yield put(BillingActions.billingInfoFetchFailed(e.response.data));
  }
}

export function* fetchInvoices() {
  try {
    yield put(BillingActions.invoicesFetchRequest());

    const page = yield select(BillingSelectors.billingPageSelector);
    const invoices = yield call(ApiService.fetchInvoices, page);

    yield put(BillingActions.invoicesFetchSucceeded(invoices));
  } catch (e) {
    yield put(BillingActions.invoicesFetchFailed(e.response.data));
  }
}

export function* addCreditCard(action) {
  try {
    const newCard = action.payload;
    const res = yield call(ApiService.addCreditCard, newCard);
    yield put(BillingActions.addCreditCardSucceeded(res));
    window.scrollTo(0, 0);
    displayNotification('success', 'Success', 'Your billing details were updated successfully');
  } catch (e) {
    yield put(BillingActions.addCreditCardFailed(e.response.data));
    displayNotification('error', 'Error', e.response.data);
  }
}

export function* addCreditCardOnBoarding(action) {
  try {
    const newCard = action.payload;
    const res = yield call(ApiService.addCreditCardOnBoarding, newCard);
    yield put(BillingActions.addCreditCardSucceeded(res));
    displayNotification('success', 'Success', 'Your billing details were updated successfully');
  } catch (e) {
    yield put(BillingActions.addCreditCardFailed(e.response.data));
    displayNotification('error', 'Error', e.response.data);
  }
}

function* trackBillingEvent() {
  try {
    MixPanel.track('Fetched billing details');
  } catch (e) {
    console.log('error tracking');
  }
}

export function* watchBilling() {
  yield SagaUtils.allIfOrgAdmin([
    yield takeEvery(BillingActions.billingInfoFetchSucceeded, trackBillingEvent),
    yield takeEvery(
      [
        BillingActions.addCreditCardSucceeded,
        BillingActions.addCreditCardOnBoardingSucceeded,
        BillingActions.billingInfoFetch,
      ],
      fetchBillingInfo,
    ),
    yield takeEvery(
      [
        BillingActions.invoicesFetch,
        BillingActions.setBillingPage,
        BillingActions.billingNextPage,
        BillingActions.billingPreviousPage,
      ],
      fetchInvoices,
    ),
    yield takeEvery(BillingActions.addCreditCard, addCreditCard),
    yield takeEvery(BillingActions.addCreditCardOnBoarding, addCreditCardOnBoarding),
  ]);
}
